import React, { useState } from 'react';
import Modal from '../../../Components/Modal';
import InputField from "../../../Components/InputField";
import Button from "../../../Components/Button";
import Validator from '../../../Components/Validator';
import { SuccessAlert, ErrorAlert } from '../../../Components/Alert';
import useAxiosCall from '../../../Hooks/useAxiosCall';

const ForgotPasswordModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [updated, setUpdated] = useState(false); // State to force re-render
  const validator = Validator();
  const [alert, setAlert] = useState({ type: '', message: '' });
  const { makeApiCall } = useAxiosCall();

  const handleInputChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validator.allValid()) {
      try {
        const requestData = {
          email: email,
        };

        await makeApiCall({
          requestData,
          onSuccess: handleApiCallSuccess,
          onError: handleApiCallError,
          requestType: 'POST',
          url: 'forgotPassword',
        });
      } catch (error) {
        console.error('API call error:', error);
      }
    } else {
      validator.showMessages();
      // Toggle the updated state to force a re-render
      setUpdated(!updated);
    }
  };

  const handleApiCallSuccess = (data) => {
    setAlert({ type: 'success', message: data.message });
  };

  const handleApiCallError = (errorMessage) => {
    setAlert({ type: 'error', message: errorMessage });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Modal.Header>Forgot Password</Modal.Header>
      <Modal.Body>
        {alert.type === 'success' && <SuccessAlert success={true} messages={[alert.message]} resetAlert={setAlert}/>}
        {alert.type === 'error' && <ErrorAlert error={true} messages={[alert.message]} resetAlert={setAlert}/>}
        <p className="mb-4">
          Enter your email address and we’ll send a link to reset your password
        </p>
        <form onSubmit={handleSubmit} noValidate>
          <div className="mb-4">
            <InputField
              type="email"
              id="emailInput"
              label="Your e-mail address"
              value={email}
              onChange={handleInputChange}
            />
            {validator.message('email', email, 'emailRequired|email')}
          </div>
          <Button type="submit">Request password</Button>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default ForgotPasswordModal;
